import React from 'react';
import { Text, makeStyles } from '@fluentui/react-components';
import EngagementLayout from './EngagementLayout';
import useEngagement from '../hooks/useEngagement';
import { customColors, customFonts } from '../../../styles';
import ChatWindowScreen from '../../ChatWindow/components/ChatWindowScreen';

const useStyles = makeStyles({
    placeholder: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: customColors.protivitiOffWhite,
    },
    placeholderText: {
        fontFamily: customFonts.TitleFont,
        fontSize: '20px',
        color: customColors.summarizeButtonDarker,
    },
});

// Phase 1 placeholders – replaced in later phases.
const InputsTabPlaceholder: React.FC = () => {
    const styles = useStyles();
    return (
        <div className={styles.placeholder}>
            <Text className={styles.placeholderText}>Inputs tab – coming in Phase 2</Text>
        </div>
    );
};

const ChatTabPlaceholder: React.FC = () => {
    const styles = useStyles();
    return (
        <div className={styles.placeholder}>
            <Text className={styles.placeholderText}>Chat tab – will be wired in Phase 2</Text>
        </div>
    );
};

// --------------------------------------------------------------------------
// EngagementPage
//
// Top-level container for the Engagement Accelerator experience.
// Phase 1 renders structural shell + tab routing with placeholder content.
// Phase 2 replaces InputsTabPlaceholder with the real inputs form components.
// Phase 2 replaces ChatTabPlaceholder with the real ChatRoom.
// --------------------------------------------------------------------------
const EngagementPage: React.FC = () => {
    const vm = useEngagement();

    // Guard: if the selected session is not an engagement session, fall through
    // to the generic no-session screen. This shouldn't normally happen because
    // the SessionWindowRouter only renders EngagementPage for engagement sessions.
    if (!vm.hasEngagementSession) {
        return <ChatWindowScreen />;
    }

    return (
        <EngagementLayout
            selectedTab={vm.selectedTab}
            visibleTabs={vm.visibleTabs}
            onTabSelect={vm.onTabSelect}
            inputsContent={<InputsTabPlaceholder />}
            chatContent={<ChatTabPlaceholder />}
        />
    );
};

export default EngagementPage;
